import React from 'react';

import { useSelector } from 'react-redux';
import cx from 'classnames';

import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { selectIsDqaEnabled, selectIsNextButtonEnabled } from '../../../store/reducers/activeProject/survey.selectors';
import { shouldRenderMobile } from '../../../utils/platform';

import styles from './index.module.scss';

export const CONTAINER_ID = 'google-recaptcha-container' as const;

export const RecaptchaTarget: React.FC = () => {
  const isDqaEnabled = useSelector(selectIsDqaEnabled);
  const isNextButtonEnabled = useSelector(selectIsNextButtonEnabled);

  if (!isFeatureEnabled(Features.recaptchaPosition)) {
    return null;
  }

  return (
    <div
      id={CONTAINER_ID}
      className={cx(styles.googleRecaptchaContainer, {
        [styles.isMobile]: shouldRenderMobile(),
        [styles.withTopRow]: isNextButtonEnabled,
        [styles.isDesktop]: !shouldRenderMobile(),
        [styles.hidden]: !isDqaEnabled,
      })}
    />
  );
};
